import { render } from "./OcrUploadFixList.vue?vue&type=template&id=cac5968a&scoped=true"
import script from "./OcrUploadFixList.vue?vue&type=script&lang=js"
export * from "./OcrUploadFixList.vue?vue&type=script&lang=js"

import "./OcrUploadFixList.vue?vue&type=style&index=0&id=cac5968a&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/00-client-web(prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cac5968a"]])

export default __exports__